<template>
  <div class="shop-apply">
    <div class="apply-body">
        <!-- 未开通状态 -->
      <template v-if="current_status == 1">
        <!-- 申请状态 -->
        <div class="top-status">
          <img
            :src="
              userInfo.shop_can_apply
                ? require('@/assets/images/icon-shop-canapply.png')
                : require('@/assets/images/icon-shop-unapply.png')
            "
            alt=""
            class="status-icon"
          />
          <div class="status-title">
            {{ userInfo.shop_can_apply ? "恭喜您" : "哎呀~非常抱歉" }}
          </div>
          <div class="status-tips">
            <template v-if="userInfo.shop_can_apply">
              <p>
                您已满足平台开店条件，成为认证设计师～现在可以正式发起开店申请，
              </p>
              <p>解锁您的专属设计店铺开启产品销售，快来开启创作变现之旅吧！</p>
            </template>
            <template v-else>
              <p>
                由于您当前还没有平台相关款式设计记录，暂未成为平台认证设计师，因此无法申请开通平台店铺，
              </p>
              <p>请先进行款式设计打样后，再来开通您的专属店铺哦~</p>
            </template>
          </div>
          <div class="apply-btn" @click="onApplyClick">
            {{ userInfo.shop_can_apply ? "申请开店" : "立即开启款式定制" }}
          </div>
        </div>
        <!-- why choose -->
        <div class="first-floor">
          <div class="floor-body">
            <div class="floor-title">为什么服装设计师们都选择我们的平台</div>
            <div class="floor-desc">
              我们为设计师提供全方位的支持,帮助您将创意转化为商业成功
            </div>
            <div class="floor-content">
              <div
                class="floor-item"
                v-for="(item, index) in floor_list"
                :key="index"
              >
                <div class="item-body">
                  <img
                    :src="
                      require(`@/assets/images/icon-floor-item-${
                        index + 1
                      }.png`)
                    "
                    alt=""
                    class="item-icon"
                  />
                  <div class="item-title">{{ item.title }}</div>
                  <div class="item-desc">{{ item.desc }}</div>
                  <div class="list-item-box">
                    <div
                      class="list-item"
                      v-for="(i, ii) in item.items"
                      :key="ii"
                    >
                      <img
                        src="@/assets/images/icon-floor-list-item.png"
                        alt=""
                        class="list-item-icon"
                      />
                      <div class="list-item-text" :title="i">{{ i }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- join -->
        <div class="second-floor">
          <div class="left-content">
            <div class="left-title">加入我们衣创社区平台</div>
            <div class="left-desc">
              让更多人看到您的才华,拓展您的设计视野,实现更大的商业价值
            </div>
            <div class="left-list">
              <div class="left-item">
                <img
                  src="@/assets/images/icon-left-choose.png"
                  alt=""
                  class="left-item-icon"
                />
                <div class="left-item-text">无需技术背景,轻松搭建线上店铺</div>
              </div>
              <div class="left-item">
                <img
                  src="@/assets/images/icon-left-choose.png"
                  alt=""
                  class="left-item-icon"
                />
                <div class="left-item-text">专业团队提供营销推广支持</div>
              </div>
              <div class="left-item">
                <img
                  src="@/assets/images/icon-left-choose.png"
                  alt=""
                  class="left-item-icon"
                />
                <div class="left-item-text">获得品牌合作和曝光机会</div>
              </div>
              <div class="left-item">
                <img
                  src="@/assets/images/icon-left-choose.png"
                  alt=""
                  class="left-item-icon"
                />
                <div class="left-item-text">参与线下赛事和时装周展示</div>
              </div>
            </div>
          </div>
          <img
            src="@/assets/images/bg-second-floor.png"
            alt=""
            class="right-img"
          />
        </div>
        <!-- support -->
        <div class="bottom-floor">
          <div class="bottom-floor-body">
            <div class="bottom-title">强大的销售网络支持</div>
            <div class="bottom-desc">
              我们拥有多元化的销售渠道和众多合作主播达人,帮助你的设计触达更广泛的受众
            </div>
            <template v-if="false">
              <div class="bottom-part-title">入驻合作主播达人</div>
              <img
                src="@/assets/images/bg-shop-apply-bottom.png"
                alt=""
                class="bottom-person-bg"
              />
            </template>
            <div class="bottom-part-title">多元化销售渠道</div>
            <div class="bottom-list">
              <div class="bottom-item">
                <div class="bottom-icon-box">
                  <img
                    src="@/assets/images/icon-earth.png"
                    alt=""
                    class="bottom-icon"
                  />
                </div>
                <div class="bottom-item-title">跨境电商</div>
                <div class="bottom-item-content">
                  对接全球主流电商平台，提供一站式跨境销售解决方案，助力设计师品牌走向国际市场。
                </div>
              </div>
              <div class="bottom-item">
                <div class="bottom-icon-box">
                  <img
                    src="@/assets/images/icon-private-sale.png"
                    alt=""
                    class="bottom-icon"
                  />
                </div>
                <div class="bottom-item-title">私域营销</div>
                <div class="bottom-item-content">
                  建立品牌专属社群，通过精细化运营提升用户粘性与复购率，打造忠实客户群体。
                </div>
              </div>
              <div class="bottom-item">
                <div class="bottom-icon-box">
                  <img
                    src="@/assets/images/icon-store.png"
                    alt=""
                    class="bottom-icon"
                  />
                </div>
                <div class="bottom-item-title">线下门店</div>
                <div class="bottom-item-content">
                  打造城市线下实体体验店与快闪店，提供线下试穿与沉浸式品牌体验。
                </div>
              </div>
              <div class="bottom-item">
                <div class="bottom-icon-box">
                  <img
                    src="@/assets/images/icon-shop-cart.png"
                    alt=""
                    class="bottom-icon"
                  />
                </div>
                <div class="bottom-item-title">电商销售</div>
                <div class="bottom-item-content">
                  入驻主流电商平台，结合平台流量与自有商城，实现多平台协同销售。
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 步骤条 -->
      <div class="apply-step-box" v-if="current_status > 1">
        <div :class="['apply-step-item', { active: current_status <= 3 }]">
          <div class="step-num">1</div>
          <div class="step-title">申请开店</div>
        </div>
        <div class="step-line"></div>
        <div :class="['apply-step-item', { active: current_status <= 3 }]">
          <div class="step-num">2</div>
          <div class="step-title">填写开店信息</div>
        </div>
        <div class="step-line"></div>
        <div :class="['apply-step-item', { active: current_status == 3 }]">
          <div class="step-num">3</div>
          <div class="step-title">提交审核</div>
        </div>
      </div>
      <!-- 申请表单 -->
      <template v-if="current_status == 2">
        <div class="apply-form">
          <div class="apply-form-body">
            <div class="apply-form-title">开店信息</div>
            <Form label-position="top" :model="form">
              <FormItem label="店铺名称">
                <Input
                  placeholder="请输入您的店铺名称"
                  v-model="form.shop_name"
                  style="max-width: 720px"
                ></Input>
              </FormItem>
              <FormItem label="店铺类型">
                <RadioGroup v-model="form.type">
                  <div class="radio-box">
                    <div :class="['radio-item', { active: form.type == 1 }]">
                      <Radio :label="1">个人店铺</Radio>
                    </div>
                    <div :class="['radio-item', { active: form.type == 2 }]">
                      <Radio :label="2">企业店铺</Radio>
                    </div>
                  </div>
                </RadioGroup>
              </FormItem>
              <FormItem v-if="form.type == 2" label="营业执照照片">
                <div class="upload-business-box">
                  <Upload
                    :action="upload_url"
                    :data="{ dir: 'template' }"
                    :before-upload="onBeforeUpload"
                    :show-upload-list="false"
                  >
                    <div class="upload-btn">
                      <!-- <img
                        v-if="
                          form.image_list && form.image_list.length > 0 &&
                          form.image_list.filter((item) => {
                            return item.key === 'business';
                          }).length > 0
                        "
                        :src="
                          form.image_list.filter((item) => {
                            return item.key === 'business';
                          })[0].value
                        "
                        alt=""
                        class="upload-ico"
                        @click="up_type = 'business'"
                      /> -->
                      <img v-if="form.business_license" :src="form.business_license" alt="" class="upload-ico" @click="up_type='business'" />
                      <img
                        v-else
                        src="@/assets/images/icon-btn-upload-business.png"
                        alt=""
                        class="upload-ico"
                        @click="up_type = 'business'"
                      />
                      <img
                        v-if="form.business_license"
                        src="@/assets/images/icon-close-circle.png"
                        alt=""
                        class="remove-ico"
                        @click.stop="onDeleteBusiness"
                      />
                    </div>
                    <div class="btn-text" @click.stop>上传营业执照正面</div>
                  </Upload>
                  <ul class="upload-tips" @click.stop>
                    <li>支持JPG/PNG/JPEG格式的图片</li>
                    <li>图片大小≤5M</li>
                    <li>
                      确保证件内容文字清晰可见，证件本身无残缺，必须加盖公章
                    </li>
                  </ul>
                </div>
              </FormItem>
              <FormItem
                :label="
                  form.type == 1 ? '个人身份证正反面' : '法人身份证正反面'
                "
              >
                <div class="id-card-box">
                  <Upload
                    :action="upload_url"
                    :data="{ dir: 'template' }"
                    :before-upload="onBeforeUpload"
                    :show-upload-list="false"
                  >
                    <div class="upload-btn">
                      <img
                        v-if="form.id_card_front"
                        :src="form.id_card_front"
                        alt=""
                        class="upload-ico"
                        @click="up_type = 'id_front'"
                      />
                      <img
                        v-else
                        src="@/assets/images/bg-id-card-front.png"
                        alt=""
                        class="upload-ico"
                        @click="up_type = 'id_front'"
                      />
                    </div>
                    <div class="btn-text" @click.stop>上传身份证正面(头像面)</div>
                  </Upload>
                  <Upload
                    :action="upload_url"
                    :data="{ dir: 'template' }"
                    :before-upload="onBeforeUpload"
                    :show-upload-list="false"
                  >
                    <div class="upload-btn">
                      <img
                        v-if="form.id_card_back"
                        :src="form.id_card_back"
                        alt=""
                        class="upload-ico"
                        @click="up_type = 'id_back'"
                      />
                      <img
                        v-else
                        src="@/assets/images/bg-id-card-back.png"
                        alt=""
                        class="upload-ico"
                        @click="up_type = 'id_back'"
                      />
                    </div>
                    <div class="btn-text" @click.stop>上传身份证反面(国徽面)</div>
                  </Upload>
                  <ul class="upload-tips" @click.stop>
                    <li>支持JPG/PNG/JPEG格式的图片</li>
                    <li>图片大小≤3M</li>
                    <li>
                      确保身份证有效，并且头像文字清晰，四角完整，无反光，无遮挡。
                    </li>
                    <span
                      >注:
                      您的证件信息只做为网站实名作用，我们将严格保密，请放心上传</span
                    >
                  </ul>
                </div>
              </FormItem>
              <FormItem label="店铺介绍">
                <div class="shop-desc">
                  <div class="desc-textarea">
                    <Input
                      type="textarea"
                      :maxlength="500"
                      :rows="10"
                      v-model="form.shop_desc"
                      placeholder="请简约介绍您的店铺、服装风格、品牌故事或创作经历..."
                    ></Input>
                    <div class="count-text">
                      {{ form.shop_desc && form.shop_desc.length ? form.shop_desc.length : 0 }} / 500
                    </div>
                  </div>
                  <span>请控制在500字以内,这将展示在您的店铺主页</span>
                </div>
              </FormItem>
              <FormItem label="店铺费用">
                <div class="fee-box">
                  <div class="fee-item">
                    <span class="fee-label">平台服务费</span>
                    <span class="fee-rate">{{ fee_config.settle_service_ratio }}%</span>
                    <span class="fee-note">使用平台交易、算法、数据等系统服务所付费用</span>
                  </div>
                  <div class="fee-item">
                    <span class="fee-label">客服服务费</span>
                    <span class="fee-rate">{{ fee_config.settle_customer_service_ratio }}%</span>
                    <span class="fee-note">平台提供咨询、售后、纠纷处理等人工服务费用</span>
                  </div>
                  <div class="cs-switch">
                    <Checkbox v-model="form.is_customer_service_open"
                      @change="onCustomerServiceChange"
                      >开通客服服务（开通后按上述客服服务费率收费）</Checkbox
                    >
                  </div>
                  <p class="fee-tip">
                    说明：未勾选开通客服服务则不收取客服服务费；实际费率以平台公示为准。
                  </p>
                </div>
              </FormItem>
              <Button class="confirm-btn" @click="onSubmit">提交申请</Button>
            </Form>
          </div>
        </div>
      </template>
      <!-- 审核状态 -->
      <template v-if="current_status == 3">
          <div class="apply-result">
              <img :src="userInfo.shop_apply_status === 'checking' ? require('@/assets/images/icon-success-green.png') : require('@/assets/images/icon-shop-apply-failed.png')" alt="" class="result-icon">
              <div class="result-title">{{ userInfo.shop_apply_status === 'checking' ? '提交成功' :'审核异常' }}</div>
              <div class="result-desc">
                  <p>{{userInfo.shop_apply_status === 'checking' ? '您的开店申请信息已提交成功!' : userInfo.shop ? `很遗憾,由于:${userInfo.shop.reject_reason},您的开店申请未通过审核~` : ''}}</p>
                  <p>{{ userInfo.shop_apply_status === 'checking' ? '我们将在3个工作日内完成审核,审核结果将通过网站系统消息通知你,请您耐心等待~' : '您可核对资质材料或补充相关信息后再次提交申请,若需了解更多,可联系平台客服获取协助' }}</p>
              </div>
              <div v-if="userInfo.shop_apply_status === 'checking'" class="view-other-btn" @click="onViewStore">逛逛其他设计师的款式商城></div>
              <div class="apply-reject-btn-box" v-else>
                  <Button class="chat-btn" @click="onCustomClick">咨询客服</Button>
                  <Button class="reapply-btn" @click="current_status = 2">重新申请</Button>
              </div>
          </div>
      </template>
    </div>
    <Chat ref="chat"></Chat>
    <create-design v-if="show_design_pop" ref="createDesign" @close-design-pop="show_design_pop=false" @on-advanced-mode="(uuid)=>{start_design(uuid)}"></create-design>
  </div>
</template>
<script>
import { getShopApplyInfo, getShopApplyFeeConfig, shopApply } from '@/api/index';
import CreateDesign from "@/components/CreateDesign";
import { uploadFileToOSS } from "@/utils/oss";
import { mapState } from "vuex";
export default {
  data() {
    return {
      floor_list: [
        {
          title: "雄厚的服装全产业链资源",
          desc: "衣创社区背后拥有雄厚的服装全产业链资源与成熟的「智能制造」体系，提供小批量定制生产服务，实现从设计到成品的无缝对接。",
          items: [
            "拥有自建现代化标准厂房与智能化流水线",
            "年均产量可达1200万套成衣、3500吨布匹",
            "拥有海外营销团队及海外仓储物流体系",
          ],
        },
        {
          title: "专业推广支持",
          desc: "我们通过多渠道营销策略，包括社交媒体、时尚活动，持续扩大全球市场份额与品牌影响力，提升您的设计曝光度。",
          items: [
            "定制化品牌故事推广",
            "社交媒体多站式作品推广",
            "打造线上设计师个人IP主页",
          ],
        },
        {
          title: "线上店铺合作部署",
          desc: "无需技术背景，快速搭建专属线上店铺，一键铺货淘宝、小红书、抖店等市场主流电商网店，连接全球消费者和采购商。",
          items: [
            "零成本开店，按需付费",
            "智能库存和订单管理",
            "一键铺货多主流电商平台",
          ],
        },
        {
          title: "线下比赛与品牌合作",
          desc: "不定期举行时尚品牌赛事，与众多知名企事业单位保持长期战略合作，持续扩大全球市场份额与品牌影响力。",
          items: [
            "业务版图遍及澳洲、美国、新西兰、柬埔寨等",
            "季度设计大赛，赢取奖金",
            "知名品牌联名合作机会",
          ],
        },
      ],
      current_status: 1,
      form: {
        shop_name: "",
        type: 1,
        shop_desc: "",
        // image_list: [],
        id_card_front:"",
        id_card_back:"",
        business_license:"",
        is_customer_service_open: false
      },
      fee_config: {
        settle_service_ratio: 0,
        settle_customer_service_ratio: 0
      },
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      uploading: false,
      uploadQueue: [],
      debounceTimer: null, // 防抖定时器
      debounceTime: 300, // 防抖时间（毫秒）
      up_type: "",
      show_design_pop:false
    };
  },
  components:{CreateDesign},
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      is_login:(state)=>state.is_login
    }),
  },
  mounted() {
    this.$store.dispatch("getUser");
    this.onGetApplyInfo();
  },
  watch: {
    current_status(newVal) {
      // 进入填写开店信息表单时加载展示费率
      if (newVal == 2) {
        this.onGetFeeConfig();
      }
    },
  },
  methods: {
    async onGetFeeConfig() {
      try {
        const { data } = await getShopApplyFeeConfig();
        if (!data) return;
        this.fee_config.settle_service_ratio = data.settle_service_ratio;
        this.fee_config.settle_customer_service_ratio =
          data.settle_customer_service_ratio;
        this.form.is_customer_service_open =
          data.is_customer_service_open == 1;
      } catch (e) {
        console.log("err-fee-config", e);
      }
    },
    async onSubmit(){
        try{
            const {form} = this;
            const {shop_name,shop_desc,business_license,id_card_back,id_card_front,type} = form;
            if(!shop_name){
              this.$layer.msg(`请填写店铺名称`);
              return;
            }
            if(!shop_desc){
              this.$layer.msg('请填写店铺简介');
              return;
            }
            
            if (type == 2 && !business_license) {
              this.$layer.msg('请上传营业执照');
              return;
            }
            
            if (!id_card_front) {
              this.$layer.msg('请上传身份证正面');
              return;
            }
            if (!id_card_back) {
              this.$layer.msg('请上传身份证反面');
              return;
            }
            // 继续执行提交逻辑
            await shopApply({
              ...form,
              is_customer_service_open: form.is_customer_service_open ? 1 : 0,
            });
            await this.$store.dispatch('getUser');
            this.onGetApplyInfo();
        }catch(e){
            console.log('err-submit',e);
        }

    },
    async onGetApplyInfo(){
        // 先确保 userInfo（含 code / shop_status）为最新，避免跳转时 uid 取空、且判定口径与 Header/Menu 一致
        await this.$store.dispatch('getUser');
        const {data} = await getShopApplyInfo()
        console.log('data',data);
        if(!data || Array.isArray(data)) return;
        // 已开店（审核通过）：直接跳转店铺管理，不应停留在申请页
        if(data.id && data.status == 1){
            this.$router.replace({
                name: "ShopManage",
                query: { uid: this.userInfo.code },
            });
            return;
        }
        if(data.id && data.status != 1){
            // console.log('aaa');
            this.current_status = 3;
        }
        this.form = data;
    },

    onCustomClick(){
        this.$refs.chat.showChat();
    },
    onViewStore(){
        console.log('前往商城...');
        this.$router.push({name:'Mall'});
    },
    onDeleteBusiness() {
      // this.form.image_list = this.form.image_list.filter((item) => {
      //   return item.key != "business";
      // });
      this.form.business_license = "";
    },
    async processAllFiles() {
      if (!this.up_type) {
        this.$layer.msg("上传失败");
        return;
      }
      const queue = [...this.uploadQueue];
      this.uploadQueue = []; // 清空队列

      console.log(`Startting upload ${queue.length} files...`);

      for (const file of queue) {
        try {
          const url = await uploadFileToOSS(file, "template");
          console.log("url==>", url);
          switch (this.up_type) {
            case "business":
              this.form.business_license = url;
              break;
            case "id_front":
              this.form.id_card_front = url;
              break;
            case "id_back":
              this.form.id_card_back = url;
              break;
          }
          console.log("image_list", this.form);
        } catch (err) {
          this.$layer.msg(`上传失败==>：${file.name}`);
        }
      }
    },
    onBeforeUpload(file) {
      console.log("file-before", file);
      this.uploading = true;
      // 将文件加入队列
      this.uploadQueue.push(file);

      // 清除旧定时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
      this.debounceTimer = setTimeout(() => {
        this.processAllFiles();
      }, this.debounceTime);
      return false;
    },
    onApplyClick() {
      const { shop_can_apply, shop_status } = this.userInfo;
      if (!shop_can_apply) {
        if(!this.is_login){
            this.$layer.msg('请先登录');
            this.$router.replace({ name: "Login" });
            return;
        }
        this.show_design_pop = true;
        return;
      }
      this.current_status = 2;
      console.log("shop_can_apply", shop_can_apply, "shop_status", shop_status);
    },
  },
};
</script>
<style lang="scss" scoped>
.shop-apply {
  display: flex;
  width: 100%;
  height: 100%;
  background: #ffffff;
  // padding-bottom: 80px;
  .apply-body {
    padding: 25px 5% 25px 40px;
    width: 100%;
    .top-status {
      width: 100%;
      background: #f5f5f5;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .status-icon {
        width: 70px;
        height: 70px;
        margin-top: 42px;
      }
      .status-title {
        color: #333333;
        font-size: 22px;
        font-weight: bold;
        margin-top: 24px;
      }
      .status-tips {
        color: #333333;
        font-size: 14px;
        text-align: center;
        margin-top: 25px;
        margin-bottom: 35px;
      }
      .apply-btn {
        background: #ff5967;
        border-radius: 20px;
        color: #ffffff;
        font-size: 14px;
        padding: 14px 25px;
        margin-bottom: 54px;
        cursor: pointer;
      }
    }
    .first-floor {
      width: 100%;
      height: 620px;
      background-image: url("../../assets/images/bg-first-floor.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      border-radius: 20px;
      margin-top: 25px;
      .floor-body {
        width: 100%;
        height: 100%;
        padding: 0 3%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .floor-title {
          font-size: 28px;
          font-weight: bold;
          color: #ffffff;
        }
        .floor-desc {
          color: #ffffff;
          font-size: 16px;
          margin-top: 20px;
          margin-bottom: 50px;
        }
        .floor-content {
          width: 100%;
          display: flex;
          column-gap: 1%;
          overflow: hidden;
          .floor-item {
            // flex: 1 0 23%;
            width:345px;
            // height: 400px;
            background: #ffffff;
            border-radius: 20px;
            .item-body {
              width:100%;
              padding: 0 19px;
              display: flex;
              flex-direction: column;
              overflow:hidden;
              .item-icon {
                width: 62px;
                height: 62px;
                margin-top: 40px;
              }
              .item-title {
                color: #1a1a1a;
                font-size: 20px;
                font-weight: bold;
                margin-top: 27px;
                white-space:nowrap;
                text-overflow:ellipsis;
                overflow:hidden;
              }
              .item-desc {
                color: #333333;
                font-size: 14px;
                margin-top: 22px;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .list-item-box {
                display: flex;
                flex-direction: column;
                row-gap: 20px;
                margin-top: 32px;
                padding-bottom: 40px;
                .list-item {
                  display: flex;
                  align-items: center;
                  column-gap: 7px;
                  .list-item-icon {
                    width: 20px;
                    height: 20px;
                  }
                  .list-item-text {
                    color: #333333;
                    font-size: 14px;
                    white-space: nowrap;
                    width: 100%;
                    text-overflow:ellipsis;
                    overflow:hidden;
                  }
                }
              }
            }
          }
        }
      }
    }
    .second-floor {
      width: 100%;
      height:100%;
      min-height:300px;
      max-height:567px;
      margin-top: 44px;
      display: flex;
      align-items: center;
      column-gap: 3%;
      .left-content {
        flex: 1;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        min-width:22%;
        .left-title {
          color: #1a1a1a;
          font-size: 28px;
          font-weight: bold;
        }
        .left-desc {
          color: #666666;
          font-size: 16px;
          margin-top: 20px;
        }
        .left-list {
          margin-top: 55px;
          display: flex;
          flex-direction: column;
          row-gap: 22px;
          .left-item {
            width: 100%;
            border-radius: 10px;
            background: #f5f5f5;
            padding: 10px;
            display: flex;
            align-items: center;
            column-gap: 20px;
            .left-item-icon {
              width: 62px;
              height: 62px;
            }
            .left-item-text {
              color: #333333;
              font-size: 18px;
              font-weight: 500;
              white-space:nowrap;
              overflow:hidden;
              text-overflow:ellipsis;
            }
          }
        }
      }
      .right-img {
        // flex: 0 0 916px;
        width:65%;
        height:100%;
        // height: 567px;
      }
    }
    .bottom-floor {
      width: 100%;
      background: #f5f5f5;
      border-radius: 20px;
      margin-top: 59px;
      .bottom-floor-body {
        padding: 0 3%;
        width: 100%;
        .bottom-title {
          width: 100%;
          text-align: center;
          padding-top: 50px;
          color: #1a1a1a;
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        .bottom-desc {
          color: #666666;
          font-size: 16px;
          text-align: center;
          width: 100%;
        }
        .bottom-part-title {
          color: #4d4d4d;
          font-size: 24px;
          font-weight: bold;
          text-align: center;
          width: 100%;
          margin-top: 69px;
          margin-bottom: 50px;
        }
        .bottom-person-bg {
          width: 100%;
          height: 100%;
        }
        .bottom-list {
          width: 100%;
          overflow: hidden;
          display: flex;
          column-gap: 16px;
          padding-bottom: 60px;
          .bottom-item {
            // flex: 0 0 350px;
            width:28%;
            height: 340px;
            background: #ffffff;
            border-radius: 20px;
            padding: 0 35px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .bottom-icon-box {
              width: 110px;
              height: 110px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #f7f7f7;
              margin-top: 30px;
              .bottom-icon {
                width: 50px;
                height: 50px;
              }
            }
            .bottom-item-title {
              margin-top: 28px;
              color: #1a1a1a;
              font-size: 26px;
              font-weight: bold;
              position: relative;
              &::after {
                content: "";
                position: absolute;
                width: 42px;
                height: 4px;
                background: #ff5967;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
              }
            }
            .bottom-item-content {
              color: #666666;
              font-size: 16px;
              margin-top: 47px;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
    .apply-step-box {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 14px;
      margin-top: 25px;
      .apply-step-item {
        display: flex;
        column-gap: 9px;
        align-items: center;
        .step-num {
          color: #ffffff;
          background: #cccccc;
          font-size: 16px;
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-radius: 100%;
        }
        .step-title {
          color: #999999;
          font-size: 16px;
        }
        &.active {
          .step-title {
            color: #333333;
          }
          .step-num {
            background: #ff5967;
          }
        }
      }
      .step-line {
        width: 30px;
        height: 2px;
        background: #ff5967;
      }
    }
    .apply-form {
      width: 100%;
      background: #fafafa;
      // border:1px solid #e0e0e0;
      border-radius: 20px;
      margin-top: 33px;
      .apply-form-body {
        padding: 40px;
        display: flex;
        flex-direction: column;
        .apply-form-title {
          color: #1a1a1a;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 30px;
          &::after {
            content: "*";
            color: red;
          }
        }
        .radio-box {
          display: flex;
          column-gap: 20px;
          .radio-item {
            width: 180px;
            height: 48px;
            background: #fafafa;
            border: 1px solid #d3d7e0;
            border-radius: 5px;
            display: flex;
            align-items: center;
            padding-left: 15px;
            &.active {
              border: 1px solid #ff5967;
            }
          }
        }
        .id-card-box {
          display: flex;
          column-gap: 30px;
        }
        .upload-business-box{
          width:100%;
          display:flex;
          align-items:center;
          column-gap:30px;
        }
        .upload-btn {
          width: 100%;
          height: 210px;
          display: flex;
          align-items: center;
          column-gap: 60px;
          position: relative;
          .remove-ico {
            position: absolute;
            top: -10px;
            right: 370px;
            width: 28px;
            height: 28px;
            cursor: pointer;
          }
          .upload-ico {
            width: 312px;
            height: 100%;
            border: 1px dashed #e0e0e0;
            border-radius: 5px;
            cursor: pointer;
            object-fit: cover;
          }
        }
        .upload-tips {
            margin-top:50px;
            height:100%;
            color: #cccccc;
          }
        .btn-text {
          margin-top: 12px;
          color: #666666;
          font-size: 12px;
          margin-left: 108px;
        }
        .shop-desc {
          display: flex;
          flex-direction: column;
          span {
            color: #999999;
            font-size: 12px;
          }
          .desc-textarea {
            width: 100%;
            max-width: 720px;
            position: relative;
            Input {
              max-width: 720px;
              resize: none;
            }
            .count-text {
              position: absolute;
              right: 10px;
              bottom: 5px;
            }
          }
        }
        .confirm-btn {
          width: 220px;
          height: 46px;
          color: #ffffff;
          background: #ff5967;
          border-radius: 23px;
        }
      }
    }
    .apply-result{
        width:100%;
        height:100%;
        max-height:704px;
        background:#fafafa;
        border-radius:20px;
        display:flex;
        // justify-content:center;
        flex-direction:column;
        align-items:center;
        margin-top:33px;
        .result-icon{
            margin-top:90px;
            width:70px;
            height:70px;
        }
        .result-title{
            color:#1a1a1a;
            font-size:28px;
            font-weight:bold;
            margin-top:32px;
        }
        .result-desc{
            color:#666666;
            font-size:16px;
            text-align:center;
            margin-top:35px;
        }
        .view-other-btn{
            color:#999999;
            font-size:14px;
            margin-top:117px;
            border-bottom:1px solid #e0e0e0;
            cursor:pointer;
        }
        .apply-reject-btn-box{
            display:flex;
            column-gap:20px;
            margin-top:100px;
            .chat-btn{
                width:160px;
                height:40px;
                border-radius:20px;
                background:#fafafa;
                border:1px solid #ff5967;
                color:#ff5967;
            }
            .reapply-btn{
                width:160px;
                height:40px;
                border-radius:20px;
                background:#ff5967;
                color:#ffffff;
            }
        }
    }
  }

  .fee-box {
    max-width: 720px;
    background: #f5f5f5;
    border-radius: 8px;
    padding: 16px 20px;
    .fee-item {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      column-gap: 12px;
      padding: 6px 0;
      .fee-label {
        color: #333333;
        font-size: 14px;
        min-width: 80px;
      }
      .fee-rate {
        color: #ff5967;
        font-size: 18px;
        font-weight: bold;
      }
      .fee-note {
        color: #999999;
        font-size: 12px;
      }
    }
    .cs-switch {
      margin-top: 10px;
    }
    .fee-tip {
      margin-top: 8px;
      color: #999999;
      font-size: 12px;
    }
  }
  @media (min-width: 1280px) and (max-width: 1679px) {
      .apply-body {
        .first-floor {
          height: 500px; // 减小高度
          .floor-body {
            .floor-title {
              font-size: 24px; // 调整字体大小
            }
            .floor-desc {
              font-size: 14px; // 调整字体大小
            }
            .floor-content {
              column-gap: 10px; // 适配间隙
              .floor-item {
                width: calc(100% / 4 - 10px); // 减小宽度以适应屏幕
                .item-body {
                  padding: 0 15px; // 减小内边距
                  .item-icon {
                    width: 50px; // 减小图标宽度
                    height: 50px; // 减小图标高度
                    margin-top: 30px; // 减小上边距
                  }
                  .item-title {
                    font-size: 18px; // 减小字体大小
                    margin-top: 20px; // 减小上边距
                  }
                  .item-desc {
                    font-size: 13px; // 减小字体大小
                    margin-top: 15px; // 减小上边距
                  }
                  .list-item-box {
                    margin-top: 20px; // 减小上边距
                    padding-bottom: 25px; // 减小底部内边距
                    row-gap: 15px; // 减小行间距
                    .list-item {
                      column-gap: 5px; // 减小列间距
                      .list-item-icon {
                        width: 16px; // 减小图标宽度
                        height: 16px; // 减小图标高度
                      }
                      .list-item-text {
                        font-size: 12px; // 减小字体大小
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .second-floor {
          max-height: 450px; // 调整高度
          .left-content {
            .left-title {
              font-size: 24px; // 调整字体大小
            }
            .left-desc {
              font-size: 14px; // 调整字体大小
            }
            .left-list{
              margin-top:20px;
            }
          }
        }
        .bottom-floor {
          .bottom-title {
            font-size: 24px; // 调整字体大小
          }
          .bottom-desc {
            font-size: 14px; // 调整字体大小
          }
          .bottom-part-title {
            font-size: 20px; // 调整字体大小
          }
          .bottom-list {
            .bottom-item {
              width: 30%; // 调整宽度以适应更小的屏幕
              height: 280px; // 调整高度
              .bottom-item-title {
                font-size: 22px; // 调整字体大小
              }
            }
          }
        }
        .apply-form {
          .apply-form-body {
            padding: 30px; // 减小内边距
            .apply-form-title {
              font-size: 16px; // 调整字体大小
            }
          }
        }
        .apply-result {
          max-height: 600px; // 调整高度
          .result-title {
            font-size: 24px; // 调整字体大小
          }
        }
      }
    }

    // 媒体查询：小于等于 1279px 屏幕尺寸
    @media (max-width: 1279px) {
      .apply-body {
        padding: 15px 3% 15px 20px; // 减小内边距
        .top-status {
          .status-icon {
            width: 60px;
            height: 60px;
            margin-top: 30px;
          }
          .status-title {
            font-size: 18px; // 调整字体大小
            margin-top: 20px;
          }
          .status-tips {
            font-size: 12px; // 调整字体大小
            margin-top: 15px;
            margin-bottom: 25px;
          }
          .apply-btn {
            padding: 10px 20px; // 减小按钮内边距
            font-size: 12px; // 调整字体大小
            margin-bottom: 40px;
          }
        }
        .first-floor {
          height: auto; // 改为自动高度，防止内容被裁剪
          margin-top: 15px; // 减小外边距
          .floor-body {
            padding: 20px 10px; // 添加内边距
            .floor-title {
              font-size: 20px; // 调整字体大小
              text-align: center; // 居中对齐
            }
            .floor-desc {
              font-size: 14px; // 调整字体大小
              text-align: center; // 居中对齐
              margin-bottom: 30px;
            }
            .floor-content {
              flex-wrap: wrap; // 允许换行
              justify-content: center; // 居中对齐
              column-gap: 15px; // 设置列间距
              row-gap: 15px; // 设置行间距
              .floor-item {
                width: 45%; // 每行显示两个项目
                min-width: 250px; // 设置最小宽度
                margin-bottom: 10px; // 添加底部间距
                flex: 0 0 auto; // 确保元素不伸缩
                .item-body {
                  padding: 0 12px; // 减小内边距
                  .item-icon {
                    width: 45px; // 减小图标宽度
                    height: 45px; // 减小图标高度
                    margin-top: 25px; // 减小上边距
                  }
                  .item-title {
                    font-size: 16px; // 减小字体大小
                    margin-top: 18px; // 减小上边距
                  }
                  .item-desc {
                    font-size: 12px; // 减小字体大小
                    margin-top: 12px; // 减小上边距
                  }
                  .list-item-box {
                    margin-top: 15px; // 减小上边距
                    padding-bottom: 20px; // 减小底部内边距
                    row-gap: 12px; // 减小行间距
                    .list-item {
                      column-gap: 5px; // 减小列间距
                      .list-item-icon {
                        width: 15px; // 减小图标宽度
                        height: 15px; // 减小图标高度
                      }
                      .list-item-text {
                        font-size: 11px; // 减小字体大小
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .second-floor {
          flex-direction: column; // 在小屏幕上改为垂直布局
          max-height: none; // 移除高度限制
          height: auto; // 改为自动高度
          margin-top: 30px; // 调整外边距
          row-gap: 20px; // 改为行间距
          .left-content {
            width: 100%; // 占满宽度
            min-width: auto; // 移除最小宽度
            .left-title {
              font-size: 20px; // 调整字体大小
              text-align: center; // 居中对齐
            }
            .left-desc {
              font-size: 14px; // 调整字体大小
              text-align: center; // 居中对齐
            }
            .left-list {
              margin-top: 30px; // 调整外边距
              row-gap: 15px; // 减小行间距
              .left-item {
                .left-item-icon {
                  width: 50px;
                  height: 50px;
                }
                .left-item-text {
                  font-size: 16px; // 调整字体大小
                }
              }
            }
          }
          .right-img {
            width: 90%; // 调整宽度
            max-width: 500px; // 设置最大宽度
          }
        }
        .bottom-floor {
          margin-top: 40px; // 调整外边距
          .bottom-floor-body {
            padding: 0 2%; // 减小内边距
            .bottom-title {
              padding-top: 30px; // 调整内边距
              font-size: 20px; // 调整字体大小
              margin-bottom: 15px;
            }
            .bottom-desc {
              font-size: 14px; // 调整字体大小
            }
            .bottom-part-title {
              font-size: 18px; // 调整字体大小
              margin-top: 40px;
              margin-bottom: 30px;
            }
            .bottom-list {
              flex-wrap: wrap; // 允许换行
              justify-content: center; // 居中对齐
              column-gap: 15px; // 设置列间距
              row-gap: 20px; // 设置行间距
              .bottom-item {
                width: 45%; // 每行显示两个项目
                min-width: 280px; // 设置最小宽度
                margin-bottom: 10px; // 添加底部间距
                height: auto; // 改为自动高度
                flex: 0 0 auto; // 确保元素不伸缩
                .bottom-icon-box {
                  width: 90px;
                  height: 90px;
                  margin-top: 20px;
                  .bottom-icon {
                    width: 40px;
                    height: 40px;
                  }
                }
                .bottom-item-title {
                  margin-top: 20px;
                  font-size: 20px; // 调整字体大小
                  &::after {
                    width: 30px;
                    height: 3px;
                    bottom: -8px;
                  }
                }
                .bottom-item-content {
                  font-size: 14px; // 调整字体大小
                  margin-top: 30px;
                }
              }
            }
          }
        }
        .apply-step-box {
          column-gap: 10px; // 减小列间距
          margin-top: 15px; // 调整外边距
          flex-wrap: wrap; // 允许换行
          .apply-step-item {
            column-gap: 6px; // 减小列间距
            .step-num {
              font-size: 14px; // 调整字体大小
              width: 24px;
              height: 24px;
              line-height: 24px;
            }
            .step-title {
              font-size: 14px; // 调整字体大小
              word-break: break-all; // 允许文本换行
            }
          }
          .step-line {
            display: none; // 在小屏幕上隐藏连接线
          }
        }
        .apply-form {
          margin-top: 20px; // 调整外边距
          .apply-form-body {
            padding: 25px; // 减小内边距
            .apply-form-title {
              font-size: 16px; // 调整字体大小
              margin-bottom: 20px;
            }
            .radio-box {
              flex-wrap: wrap; // 允许换行
              row-gap: 10px; // 添加行间距
              column-gap: 10px; // 减小列间距
              .radio-item {
                width: calc(50% - 10px); // 每行显示两个项目
                min-width: 140px; // 设置最小宽度
                height: 40px; // 减小高度
                padding-left: 12px;
              }
            }
            .id-card-box {
              flex-direction: column; // 改为垂直布局
              row-gap: 15px; // 添加行间距
            }
            .upload-btn {
              flex-direction: column; // 改为垂直布局
              row-gap: 15px; // 添加行间距
              height: auto; // 改为自动高度
              .remove-ico {
                position: absolute;
                top: -10px;
                right: 10px; // 调整位置
                width: 24px;
                height: 24px;
              }
              .upload-ico {
                width: 100%; // 占满宽度
                max-width: 300px; // 设置最大宽度
                height: 150px;
              }
            }
            .btn-text {
              margin-top: 10px; // 调整外边距
              font-size: 11px; // 调整字体大小
              margin-left: 0; // 移除左边距
              text-align: center; // 居中对齐
            }
            .shop-desc {
              .desc-textarea {
                .count-text {
                  font-size: 11px; // 调整字体大小
                }
              }
            }
            .confirm-btn {
              width: 100%; // 占满宽度
              max-width: 200px; // 设置最大宽度
              height: 40px; // 减小高度
              margin: 0 auto; // 居中对齐
            }
          }
        }
        .apply-result {
          max-height: none; // 移除高度限制
          height: auto; // 改为自动高度
          margin-top: 20px; // 调整外边距
          .result-icon {
            margin-top: 40px; // 调整外边距
            width: 60px;
            height: 60px;
          }
          .result-title {
            font-size: 20px; // 调整字体大小
            margin-top: 25px;
          }
          .result-desc {
            font-size: 14px; // 调整字体大小
            margin-top: 25px;
          }
          .view-other-btn {
            font-size: 12px; // 调整字体大小
            margin-top: 40px; // 调整外边距
          }
          .apply-reject-btn-box {
            flex-wrap: wrap; // 允许换行
            row-gap: 10px; // 添加行间距
            column-gap: 10px; // 减小列间距
            margin-top: 40px; // 调整外边距
            .chat-btn {
              width: 100%; // 占满宽度
              max-width: 200px; // 设置最大宽度
              height: 36px; // 减小高度
            }
            .reapply-btn {
              width: 100%; // 占满宽度
              max-width: 200px; // 设置最大宽度
              height: 36px; // 减小高度
            }
          }
        }
      }
    }
}

::v-deep .ivu-radio-checked .ivu-radio-inner {
  border-color: #ff5967;
}

::v-deep .ivu-radio-inner::after {
  background-color: #ff5967;
}

// 勾选后的 Checkbox 使用系统红
::v-deep .ivu-checkbox-wrapper:hover .ivu-checkbox-inner,
::v-deep .ivu-checkbox:hover .ivu-checkbox-inner {
  border-color: #ff5967;
}

::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
  border-color: #ff5967;
  background-color: #ff5967;
}

::v-deep .ivu-checkbox-checked .ivu-checkbox-inner::after {
  border-color: #ffffff;
}

::v-deep textarea {
  resize: none;
}
</style>
